import type { CashManagementProviderAccount } from "../models/CashManagement";

export const returnProperCashManagementProviderAccountObject = (
  cashManagementProviderAccount: CashManagementProviderAccount
) => {
  return {
    cashManagementProviderAccount: {
      cashManagementProvider:
        cashManagementProviderAccount?.cashManagementProvider?.id ?? null,
      ...(cashManagementProviderAccount?.additionalConfiguration
        ? {
            additionalConfiguration:
              cashManagementProviderAccount.additionalConfiguration,
          }
        : {}),
      settlementEnabled:
        cashManagementProviderAccount?.settlementEnabled ?? false,
    },
  };
};
